import type { CustomAttributeFilterControl } from 'lib-analytics-types';

import { CustomFieldAttributeType } from 'apis/customFields';

export const customAttributesFilterAssets: Record<
  CustomFieldAttributeType,
  {
    readonly operators: readonly CustomAttributeFilterControl['operator'][];
  }
> = {
  text: {
    operators: ['is_not_empty', 'is_empty'],
  },
  select: {
    operators: ['is_one', 'is_not_one', 'is_empty', 'is_not_empty'],
  },
};
